import voucherService from "../services/voucher.service";
import {
  FETCH_VOUCHERS_LIST,
  FETCH_VOUCHERS_LIST_FAILURE,
  FETCH_VOUCHERS_LIST_SUCCESS,
} from "./types";

export const retrieveVouchersList = (param) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_VOUCHERS_LIST });
    const res = await voucherService.getAllVouchers(param);
    dispatch({
      type: FETCH_VOUCHERS_LIST_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: FETCH_VOUCHERS_LIST_FAILURE,
    });
    console.log(err);
  }
};
